import { CategoryMegaMenuSubCategoryColumn } from '@/widgets/Navbar/DesktopMenu/_components/CategoryMegaMenu/_components/CategoryMegaMenuSubCategoryColumn';

import { CategoryMegaMenuMasonryColumnsProps } from './models';

export const CategoryMegaMenuMasonryColumns = ({ columns, isDark, onNavigate, className }: CategoryMegaMenuMasonryColumnsProps) => (
    <div className={className}>
        {columns.map((column, columnIndex) => (
            <div key={columnIndex} className='flex min-w-0 flex-1 flex-col gap-y-6'>
                {column.map((subCategory) => (
                    <CategoryMegaMenuSubCategoryColumn key={subCategory.id} subCategory={subCategory} isDark={isDark} onNavigate={onNavigate} />
                ))}
            </div>
        ))}
    </div>
);
